import GMap from '../components/5templates/GMap'
import makeStyles from '@material-ui/core/styles/makeStyles'
import useMediaQuery from '@mui/material/useMediaQuery'
import MapSearch from '../components/3modules/MapSearch'
import Popup from '../components/5templates/Popup'
import MobileMenu from '../components/5templates/MobileMenu'
import { Authenticate } from '../common/sessionGate'
import Loader from '../components/1elements/Loader'
import { useAppzi } from '../services/appzi/useAppzi'
import { useWelcomeMessage } from '../services/welcomeMessage/useWelcomeMessage'
import { checkSession } from '../common/sessionGate'
import { useGMapLoad } from '../sharedcomponents/5templates/googleMap/useGMapLoad'
import MapSettingButton from '../components/1elements/Buttons/IconButtons/MapSettingButton'
import { isAllowedToAccessAdminDashboard } from '../services/permissions/permissionHelper'

function MapView() {
  checkSession()

  const classes = useStyles()
  const resize = useMediaQuery('(max-width:750px)')
  const { firstTime } = useWelcomeMessage()
  const { loadMap } = useGMapLoad()

  // Load Appzi
  useAppzi()

  return (
    <div className={`${classes.root} ${resize && classes.resized}`}>
      {resize && <MobileMenu />}
      <MapSearch animation={false} />
      {!loadMap ? <Loader /> : <GMap />}

      {/*TODO IAM check for map setting*/}
      {isAllowedToAccessAdminDashboard() && (
        <MapSettingButton className={classes.mapSettingButton} />
      )}

      {firstTime && <Popup />}
    </div>
  )
}

export default Authenticate(MapView)

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 60,
    height: '99vh',
    position: 'relative',
    width: '100%'
    // overflowY: 'hidden',
  },
  resized: {
    marginLeft: 0
  },
  mapSettingButton: {
    position: 'fixed',
    zIndex: 10,
    right: '60px',
    bottom: '23px'
  }
}))
